<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     日期范围选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-date-picker
    v-model="pickedRange"
    class="f-date-range-picker "
    :pop-class="border"
    type="daterange"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    value-format="timestamp"
    :style="{ width: width + 'px' }"
    :picker-options="options"
    @change="handleChange" />
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime()
export default {
  name: 'FDateRangePicker',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: String,
      default: '240'
    },
    range: {
      type: Array,
      default() {
        return []
      }
    },
    shortcuts: {
      type: Array,
      default() {
        return []
      }
    },

    border: {
      type: String,
      default: 'border'
    },
  },
  data() {
    var disabledDate = (date) => {
      if (this.range) {
        if (this.range.length === 1) {
          return date.getTime() < this.range[0] * 1000
        } else {
          return date.getTime() < this.range[0] * 1000 || date.getTime() > this.range[1] * 1000
        }
      } else {
        return false
      }
    }
    const shortcuts = []
    const choices = [
      { text: '今天', num: 0 },
      { text: '最近一周', num: -7 },
			{ text: '最近一个月', num: -30 },
			{ text: '最近三个月', num: -90 },
			{ text: '最近六个月', num: -180 },
			{ text: '最近六个月', num: -360 },
			{ text: '昨天', num: -1 },			
			{ text: '明天', num: 1 },
			{ text: '往后一周', num: 7 },
			{ text: '往后一个月', num: 30 },
			{ text: '往后三个月', num: 90 },
			{ text: '往后六个月', num: 180 },
			{ text: '往后六个月', num: 360 },
    ]
    if (this.shortcuts.length > 0) {
      for (const c of choices) {
        if (this.shortcuts.indexOf(c.num) > -1) {
          shortcuts.push({
            text: c.text,
            onClick(picker) {
              picker.$emit('pick', [today + 3600 * 1000 * 24 * c.num, today])
            }
          })
        }
      }
    }
    if (shortcuts.length) {
      return {
        options: {
          shortcuts: shortcuts,
          disabledDate: disabledDate
        }
      }
    } else {
      return {
        options: {
          disabledDate: disabledDate
        }
      }
    }
  },
  computed: {
    pickedRange: {
      get() {
        if (this.value !== null) {
          return [this.value[0] * 1000, this.value[1] * 1000]
        } else {
          return null
        }
      },
      set(val) {
        if (val !== null) {
          val[0] /= 1000
          val[1] = val[1] / 1000 + 86399
        }
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.f-date-range-picker {
  &.el-date-editor {
    .el-range-separator {
      width: 10%;
      color: #c0c4cc;
    }
  }
}
</style>
